import axios from 'axios'
const header = {
  'x-api-key': process.env.REACT_APP_X_API_KEY_LEVY_SCHEME
}
export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_LEVY_SCHEME,
  headers: { ...header }
})